import React from "react";
import CallBack from "../Home/components/CallBack";

const ContactUs = () => {
  return (
    <div>
      <CallBack />
    </div>
  );
};

export default ContactUs;
